import { z } from "zod";

export const experienceItemSchema = z.object({
  id: z.string().optional(),
  organization: z.string().min(1, "Organization is required").max(300, "Organization too long"),
  role: z.string().min(1, "Role is required").max(300, "Role too long"),
  department: z.string().max(200, "Department too long").optional().nullable(),
  startDate: z.string().min(1, "Start date is required").max(50, "Start date too long"),
  endDate: z.string().max(50, "End date too long").optional().nullable(),
  current: z.boolean().default(false).optional(),
  location: z.string().max(200, "Location too long").optional().nullable(),
  description: z.string().max(3000, "Description too long").optional().nullable(),
});

export type ExperienceItem = z.infer<typeof experienceItemSchema>;


import { getSectionDisplayOptionsSchema } from "../display-options";

export const experienceDisplayOptionsSchema = getSectionDisplayOptionsSchema("experience");
export type ExperienceDisplayOptions = z.infer<typeof experienceDisplayOptionsSchema>;

export const experienceContentSchema = z.object({
  heading: z.string().max(200).default("Experience").optional(),
  items: z.array(experienceItemSchema).max(50, "Maximum 50 experience items allowed"),
  displayOptions: experienceDisplayOptionsSchema.optional(),
});

export type ExperienceContent = z.infer<typeof experienceContentSchema>;
